import { render } from "./PlanPricingNotice.vue?vue&type=template&id=122e5359"
import script from "./PlanPricingNotice.vue?vue&type=script&lang=js"
export * from "./PlanPricingNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__